import { Inject, Injectable, inject } from '@angular/core';
import { BaseCrudService } from '@t-llevo/common-ui';
import { HttpClient } from '@angular/common/http';
import { Environment, ResponseData } from '@t-llevo/util';
import { UserService } from './user.service';
import { map } from 'rxjs';
import { apiTravelRoutes as apiRoutes } from '../routes/api-travel-routes';
import { TravelResponse } from '../models/responses/TravelResponse';
import { Travel } from '../../common/models/Travel';
import { TravelMapper } from '../mappers/TravelMapper';

@Injectable()
export class TravelService extends BaseCrudService<
  Travel,
  ResponseData<TravelResponse>
> {
  private userSrv = inject(UserService);
  constructor(@Inject(Environment) env: Environment, http: HttpClient) {
    super(env, http);
  }

  override transform(data: ResponseData<TravelResponse>): ResponseData<Travel> {
    return {
      count: data.count,
      results: data.results.map((travel) => TravelMapper(travel)),
      limit: data.limit,
      page: data.page,
    };
  }

  getTravels() {
    return this.http.get<ResponseData<TravelResponse>>(
      `${this.env.apiUrl}${apiRoutes.routeTravel}`,
    );
  }

  getTravelById(id: string) {
    return this.http
      .get<TravelResponse>(this.env.apiUrl + apiRoutes.routeTravel + `/${id}`)
      .pipe(map((data) => TravelMapper(data)));
  }

  getClients() {
    return this.userSrv
      .getUsers()
      .pipe(
        map((obsData) =>
          obsData.results.filter((item) => item.roles.includes('client')),
        ),
      );
  }

  getClientById(id: string) {
    return this.getClients().pipe(
      map((data) => data.find((item) => item.id == id)),
    );
  }
}
